export function isNearlyGone(spreadPercentage?: number) {
  return Boolean(spreadPercentage && spreadPercentage <= 20)
}
